import React from 'react';
import './DataFieldTag.scss';

// TODO: move this to ui-components
export interface DataFieldTagProps {
  text: string;
  className?: string;
}

const DataFieldTag = ({ text, className }: DataFieldTagProps) => (
  <div className={`data-field-tag ${className ? className : ''}`}>{text}</div>
);

export default DataFieldTag;
